// Stub. Per-user preferences aren't on the Phase-1c critical path; reserved
// here so the nav highlight has a target.

import { AdminShell } from '@/components/AdminShell';

export function SettingsPage() {
  return (
    <AdminShell>
      <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
      <p className="mt-2 text-slate-600">No settings yet.</p>
    </AdminShell>
  );
}
